import { ajax } from 'rxjs/ajax'
import { map } from 'rxjs'
import type { Observable } from 'rxjs'
import { Environment } from '../../environment.ts'

/* Long enough to survive a slow-but-alive backend, short enough that the probe
 * cadence stays meaningful. */
const PROBE_TIMEOUT_MS = 5000

/*
 * Liveness probe for the connectivity layer.
 *
 * Deliberately NOT routed through the shared get()/tracedAjax() helpers:
 * - no credentials, so an expired token can never look like an outage,
 * - no Sentry tracing, so a backend that is down does not produce a stream of
 *   breadcrumbs and error noise while we poll it,
 * - its own short timeout, so a hanging socket does not stall the probe loop.
 *
 * /health is unauthenticated and returns a 15-byte {"status":"UP"} body.
 */
export const checkHealth = (): Observable<boolean> =>
  ajax({
    url: `${Environment.API_URL}/health`,
    method: 'GET',
    timeout: PROBE_TIMEOUT_MS
  }).pipe(map((response) => response.status >= 200 && response.status < 400))
